<mat-select #surveySelect [placeholder]="placeholder" (selectionChange)="onSelectionChange()"
    (openedChange)="openedChange($event)" [compareWith]="compareWith" [disabled]="isDisabled" [formControl]="selectCtrl"
    [tabIndex]="tabIndex">

    <mat-option *ngFor="let item of (surveyList$ | async) | orderBy: 'name': false"
        [value]="item.surveyId">{{item.name}}</mat-option>

</mat-select>